import Swal from 'sweetalert2'
import {
  IconPaths,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { Button } from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { Params } from '../../core/_params'
import { getRelatorioGestaoAtendimentosCSV } from '../../core/_requests'

type Props = {
  /** Chamado quando falta o período (campo + datas): a busca destaca os campos obrigatórios. */
  onPeriodoIncompleto: () => void
}

/** Exportação CSV do relatório de gestão — exige o período completo. */
export const AtendimentoGestaoListToolbar = ({ onPeriodoIncompleto }: Props) => {
  const { query } = useQueryResponse()
  const { state } = useQueryRequest<Params>()

  const empresaId = state.params?.empresa?.value
  const periodoCompleto = !!(state.params?.range && state.params?.inicio && state.params?.fim)

  const exportarCsv = async () => {
    if (!periodoCompleto) {
      onPeriodoIncompleto()
      return
    }

    const buscarFilhas = await showConfirmAlert({
      title: 'Incluir as instituições filhas?',
      text: 'Incluir as filhas pode levar alguns minutos, dependendo da quantidade.',
      icon: 'info',
      confirmButtonText: 'Sim, incluir',
      cancelButtonText: 'Não, só esta',
    })

    const csvQuery = [
      query,
      empresaId ? `empresa=${empresaId}` : '',
      buscarFilhas ? 'buscarFilhas=true' : '',
    ]
      .filter(Boolean)
      .join('&')

    try {
      showAlertLoading()
      const { data } = await getRelatorioGestaoAtendimentosCSV(csvQuery)
      Swal.close()
      window.open(data.URL, '_blank')
    } catch (error) {
      showError(error)
    }
  }

  return (
    <Button
      className='btn-primary'
      icon={IconPaths.Csv}
      onClick={exportarCsv}
      title={periodoCompleto ? undefined : 'Informe o período para exportar'}
    >
      Exportar CSV
    </Button>
  )
}
